import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSubheader } from "../../../../_metronic/layout";
import ProposalManageCard from "./ProposalManageCard";
import ProposalDetailPage from "./ProposalDetailPage";
import * as proposalService from "../../../../services/service/proposalService";
import ProposalContactLogPage from "./ProposalContactLogPage";
import ProposalAttachmentPage from "./ProposalAttachmentPage";
import ProposalReviewerLogsPage from "./ProposalReviewerLogsPage";
import ProposalContentPage from "./ProposalContentPage";
import ProposalEstimatorPage from "./ProposalEstimatorPage";
import ProposalMobileNavigation from "./ProposalMobileNavigation";

const ProposalManagerPage = (props) => {
    const { location, auth } = props
    const [proposalId] = useState(location.pathname.split('/').pop());
    const [proposalPermission, setProposalPermission] = useState({
        userRole: "",
        hasReviewed: false,
        dateReviewed: null
    });

    const [proposalManageData, setProposalManageData] = useState({
        proposalNumber: "",
        projectNumber: "",
        createdBy: "",
        createdOn: "",
        jobId:0,
        proposalNumber: "",
        submittedBy: "",
        submittedOn: ""
    });

    const suhbeader = useSubheader();
    suhbeader.setTitle("Manage Proposal");

    useEffect(() => {
        proposalService.GetProposalManageInfo(proposalId).then(res => {
            setProposalManageData(res);
        });

        proposalService.GetUserPermissionForProposal(proposalId).then(res => {
            setProposalPermission(res);
        }).catch(ex => console.log(ex));
    }, []);

    return (
        <div className="aes-proposal-manage-layout d-flex flex-row">
            <ProposalManageCard {...props} proposalPermission={proposalPermission} updateProposalPermission={setProposalPermission} proposal={proposalManageData} proposalId={proposalId}></ProposalManageCard>
            <div className="aes-proposal-manage-content flex-row-fluid ml-lg-8">
                <ProposalMobileNavigation proposalId={proposalId} proposal={proposalManageData} />
                <Switch>
                    <Redirect
                        from="/services/manage-proposal/:id"
                        exact={true}
                        to="/services/manage-proposal/general-information/:id"
                    />
                    <Route
                        path="/services/manage-proposal/general-information/:id"
                        render={() => <ProposalDetailPage isReadOnly={proposalManageData.submittedOn !== "-"} proposalPermission={proposalPermission} proposalIdParam={proposalId} />}
                    />
                    <Route
                        path="/services/manage-proposal/proposal-content/:id"
                        render={() => <ProposalContentPage isReadOnly={proposalManageData.submittedOn !== "-"} proposalPermission={proposalPermission} proposalIdParam={proposalId} />}
                    />
                    <Route
                        path="/services/manage-proposal/proposal-estimator/:id"
                        render={() => <ProposalEstimatorPage isReadOnly={auth.isAdmin ? false : proposalManageData.submittedOn !== "-"} proposalPermission={proposalPermission} proposalIdParam={proposalId} />}
                    />
                    <Route
                        path="/services/manage-proposal/contact-logs/:id"
                        render={() => <ProposalContactLogPage isReadOnly={proposalManageData.submittedOn !== "-"} proposalPermission={proposalPermission} proposalId={proposalId} />}
                    />
                    <Route
                        path="/services/manage-proposal/attachments/:id"
                        render={() => <ProposalAttachmentPage isReadOnly={proposalManageData.submittedOn !== "-"} proposalPermission={proposalPermission} proposalId={proposalId} />}
                    />
                    <Route
                        path="/services/manage-proposal/reviewer-logs/:id"
                        render={() => <ProposalReviewerLogsPage proposalPermission={proposalPermission} proposalId={proposalId} />}
                    />
                </Switch>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    auth: state.auth
});


export default connect(mapStateToProps, null)(ProposalManagerPage);
